// removed by extract-text-webpack-plugin
module.exports = {"header-container":"SlotsListHeader__header-container___1Z3_u"};